import styled from 'styled-components';

import { adSlotConfig } from '../../ad-slot-config';
import { useDefineSlot } from '../../hooks/use-define-slot';

const AdContainer = styled.div`
  min-height: 90px;
`;

export const DisplayAdLoginLeaderboard: React.FC<{ refresh: boolean }> = ({
  refresh,
}) => {
  const slotConfig = adSlotConfig.Login.Leaderboard;
  useDefineSlot({ ...slotConfig, refresh });

  return <AdContainer id={slotConfig.id} />;
};
